import {
  MODEL_ID,
  PROVIDER,
  ACTION,
  MODE,
} from 'Pods/ThreeDStudio/Store/constants'

export default {
  "model_id": MODEL_ID.MESHY_ANIMATION_PRO,
  "provider": PROVIDER.MESHY,
  "action": ACTION.ANIMATION,
  "mode": MODE.NORMAL,
  "input_schema": {
    "type": "object",
    "properties": {
      "input_3d": {
        "type": "string",
        "allowedTypes": ['glb', 'gltf', 'fbx', 'obj', 'stl'],
        "maxFileSize": 200 * 1024 * 1024,
      },
      // Both engines carry the picked clip as `animation` so the store mapping
      // stays single; for Meshy the value is the numeric Animation Library id
      // (the BE persists it into an integer column, action_code) and
      // keyToConvert renames it to the action_id the allow-list expects.
      "animation": {
        "type": "integer",
        "minimum": 0,
      },
    },
    // action_id is required by the BE (Meshy's animation_rules) but stays out of
    // this list: useAreRequiredParamsFulfilled resolves a required param against
    // modelSettings/state, never the per-tab animateSettings slice, so declaring
    // it here would disable the generate button forever. The Animate tab gates
    // the button on the selection instead.
    "required": ["input_3d"],
    "additionalProperties": false,
  },
  "ui_schema": {},
  "active_if": {},
  "keyToConvert": [
    { "from": "animation", "to": "action_id" },
  ],
}
